import { gql } from '@apollo/client';

const getReceiptsPaginated = gql`
  query getReceiptsPaginated(
    $page: Int
    $pageSize: Int
    $sortField: String
    $sortOrder: String
    $filters: ReceiptFilter
    $search: String
  ) {
    getReceiptsPaginated(
      page: $page
      pageSize: $pageSize
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
      search: $search
    ) {
      rows {
        id
        author_id
        agent_id
        booking_account_id
        tax_id
        price
        description
        month
        year
        type
        exported_at
        accounting_receipt_id
        export_to_accounting_id
        agent {
          surname
          name
          agent_id
        }
      }
      totalCount
    }
  }
`;

export default getReceiptsPaginated;
